import { Outlet } from 'react-router';
import { Box, Container } from '@mui/material';

import { AppErrorBoundary } from '@/shared/ui/app-error-boundary/AppErrorBoundary';
import { HomeBottomNav } from '@/components/home/HomeBottomNav';
import { HomeLeftNav } from '@/components/home/HomeLeftNav';
import Contexts from './Contexts';
import UserWarningMessages from '@/components/home/UserWarningMessages';
import VersionUpdate from '@/components/home/VersionUpdate';
import { Onboarding } from '@/components/onboarding/Onboarding';
import NewVewsionPopup from '@/components/sysinfo/NewVersionPopup';
import { PopupType } from './types';

import './Layout.css';

function Common() {
  return (
    <>
      <UserWarningMessages />
      <VersionUpdate />
      <Onboarding />
      <NewVewsionPopup />
    </>
  );
}

export function Layout({ popups, isPhone }: { popups: PopupType[]; isPhone: boolean }) {
  return isPhone ? (
    <Contexts>
      <div className="home-main-phone">
        <AppErrorBoundary boundaryId="app-widgets">
          <Common />
        </AppErrorBoundary>
        <div className="sizeadjustment">
          <div className="scrollable phone">
            <Outlet />
          </div>
        </div>
        <HomeBottomNav popups={popups} />
      </div>
    </Contexts>
  ) : (
    <Contexts>
      <>
        <AppErrorBoundary boundaryId="app-widgets">
          <Common />
        </AppErrorBoundary>
        <div className="scrollable">
          <HomeLeftNav popups={popups} />
          <Box className="home">
            <Container component="main" className="home-main" maxWidth={false}>
              <Outlet />
            </Container>
          </Box>
        </div>
      </>
    </Contexts>
  );
}
